import React from 'react';
import Configurator from 'content/Configurator';

const ConfiguratorBlock = () => <Configurator />;

export default ConfiguratorBlock;
